export const environment = {
  production: false,
  // Host only: the API path (/api/v2/marketplace) is the same for every partner and is
  // appended at runtime (see PartnerContextService.apiBaseUrl).
  apiHost: 'https://api-m.sandbox.stretchitlive.tech'
};
